<template>
  <ul class="breadcrumb">
    <li class="breadcrumb-item" v-for="item in data" :key="item.name">
      <lr-link :to="item.url">{{ item.name }}</lr-link>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [
        {
          name: '首页',
          url: '',
        },
        {
          name: 'Office技巧',
          url: '',
        },
      ],
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  background: #fff;
  padding: 0;
  margin-bottom: 20px;
  text-align: left;

  &-item {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    margin-right: 5px;

    &:first-of-type {
      border-left: 3px solid #417ff9;
      padding-left: 7px;
    }

    &:not(:first-of-type)::before {
      content: '>';
      height: 20px;
      vertical-align: middle;
      padding: 0 5px;
      color: #ccc;
    }
  }
}
</style>